import { heroAnime, updateTicker, siteStats } from "@/mocks/anime";

export default function Hero() {
  const tickerList = [...updateTicker, ...updateTicker];

  return (
    <section id="top" className="relative w-full pt-16">
      <div className="absolute inset-0">
        <img
          src={heroAnime.image}
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-black/70"></div>
      </div>

      <div className="relative w-full">
        {/* 更新条压顶 */}
        <div className="w-full bg-primary-600 text-background-50">
          <div className="w-full px-4 md:px-8 h-10 flex items-center gap-3 md:gap-5 overflow-hidden">
            <span className="shrink-0 flex items-center gap-1.5 text-xs font-medium whitespace-nowrap">
              <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse" aria-hidden="true"></span>
              今日更新
            </span>
            <div className="flex-1 overflow-x-auto md:overflow-hidden">
              <div className="flex items-center gap-4 md:gap-6 whitespace-nowrap">
                {tickerList.map((item, index) => (
                  <a
                    key={`${item.id}-${index}`}
                    href="#recommend"
                    className="flex items-center gap-2 text-xs md:text-[13px] text-background-100 hover:text-background-50 transition-colors"
                  >
                    <i className="ri-play-list-add-line text-sm text-accent-300" aria-hidden="true"></i>
                    <span className="font-medium">{item.title}</span>
                    <span className="text-background-200/80 hidden sm:inline">{item.info}</span>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* 首屏内容 */}
        <div className="w-full px-4 md:px-8 pt-12 pb-16 md:pt-20 md:pb-24">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center">
            <div className="lg:col-span-7 animate-fade-rise">
              <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-background-50/15 text-background-50 text-xs md:text-sm mb-5 backdrop-blur">
                <i className="ri-sparkling-2-fill text-accent-300" aria-hidden="true"></i>
                日漫 · 国漫 · 剧场版 · OVA
              </span>
              <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight">
                {heroAnime.title}
              </h1>
              <p className="mt-4 text-lg md:text-2xl text-background-100 font-heading">
                {heroAnime.subtitle}
              </p>
              <p className="mt-5 max-w-2xl text-sm md:text-base leading-relaxed text-background-200/90">
                {heroAnime.description}
              </p>

              <div className="mt-8 flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
                <a
                  href="#recommend"
                  className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm md:text-base font-medium whitespace-nowrap transition-colors hover:bg-primary-600 cursor-pointer"
                >
                  <i className="ri-fire-line text-lg" aria-hidden="true"></i>
                  查看本季推荐
                </a>
                <a
                  href="#guide"
                  className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-background-50/15 text-background-50 text-sm md:text-base font-medium whitespace-nowrap backdrop-blur transition-colors hover:bg-background-50/25 cursor-pointer"
                >
                  <i className="ri-road-map-line text-lg" aria-hidden="true"></i>
                  从补番指南开始
                </a>
              </div>

              <div className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
                {siteStats.map((stat) => (
                  <div key={stat.label} className="flex items-center gap-3">
                    <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-50/15 text-accent-300">
                      <i className={`${stat.icon} text-xl`} aria-hidden="true"></i>
                    </span>
                    <span className="flex flex-col">
                      <span className="font-heading text-lg md:text-xl font-bold text-background-50">
                        {stat.value}
                      </span>
                      <span className="text-xs text-background-200/80">{stat.label}</span>
                    </span>
                  </div>
                ))}
              </div>
            </div>

            {/* 实时更新卡片 */}
            <div className="lg:col-span-5">
              <div className="rounded-lg bg-background-50/95 backdrop-blur border border-background-200/70 overflow-hidden">
                <div className="flex items-center justify-between px-4 md:px-5 h-12 border-b border-background-200/70 bg-background-100">
                  <span className="flex items-center gap-2 font-heading font-bold text-foreground-950">
                    <i className="ri-time-line text-primary-500" aria-hidden="true"></i>
                    实时更新
                  </span>
                  <span className="text-xs text-foreground-500">刚刚刷新</span>
                </div>
                <div className="h-72 md:h-80 overflow-hidden relative">
                  <div className="animate-marquee-up">
                    {tickerList.map((item, index) => (
                      <a
                        key={`card-${item.id}-${index}`}
                        href="#recommend"
                        className="flex items-center justify-between gap-3 px-4 md:px-5 py-3 border-b border-background-200/60 hover:bg-primary-50 transition-colors"
                      >
                        <span className="flex items-center gap-3 min-w-0">
                          <span className="w-8 h-8 shrink-0 flex items-center justify-center rounded-md bg-primary-100 text-primary-700">
                            <i className="ri-play-fill text-sm" aria-hidden="true"></i>
                          </span>
                          <span className="min-w-0">
                            <span className="block text-sm font-medium text-foreground-950 truncate">
                              {item.title}
                            </span>
                            <span className="block text-xs text-foreground-500 truncate">{item.info}</span>
                          </span>
                        </span>
                        <span className="shrink-0 text-xs text-foreground-400">{item.time}</span>
                      </a>
                    ))}
                  </div>
                </div>
              </div>
              <p className="mt-3 text-xs text-background-200/70 text-center">
                每一条都是本页内的示例更新记录，方便你先了解站点节奏。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}